import type { IBannerInfo, IBannerRestriction } from '@/interface/IBannerInfo';
import { BannerAction, GameFrom } from '@/interface/enum';
import type { BannerInfo, BannerRestriction } from '@/interface/pollux';

export function formatBanner(bannerInfos: BannerInfo[]): IBannerInfo[] {
    return bannerInfos.map(bannerInfo => ({
        cdn: bannerInfo.cdn ?? '',
        chinaCdn: bannerInfo.chinaCdn ?? '',
        action: BannerAction.fromPollux(bannerInfo.action),
        actionDetail: bannerInfo.actionDetail ?? undefined,
        id: bannerInfo.id,
        restrictions: bannerInfo.restrictions ? formatRestriction(bannerInfo.restrictions) : [],
        trackingCode: bannerInfo.trackingCode ?? '',
        remark: bannerInfo.remark,
        gameFrom: GameFrom.fromPollux(bannerInfo.gameFrom),
    }));
}

function formatRestriction(restrictions: BannerRestriction[]): IBannerRestriction[] {
    return restrictions.map(restriction => ({
        subId: restriction.subId,
        brands: restriction.brands ?? [],
        licenses: restriction.licenses ?? [],
        countries: restriction.countries ?? [],
        sboCurrencies: restriction.sboCurrencies ?? [],
        memberStatus: restriction.memberStatus ?? [],
    }));
}
